import React, { useRef, useEffect } from "react";
import { func, string } from "prop-types";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  GeneralStyle,
  FormCard,
  SectionWrapper,
} from "./CategoriesForm.styled";
import {
  SAVE_SURVEY_CATEGORY,
  SAVE_QUESTION_CATEGORY,
  UPDATE_CATEGORY_QUESTION,
  UPDATE_CATEGORY_SURVEY,
  CREATE_THEME,
  UPDATE_THEME,
} from "../../GraphQL/Mutations";
import { useMutation } from "@apollo/client";
import { getStateLogin } from "../../containers/LayoutHome/stateLogin";
import { NotificationManager } from "react-notifications";
import { clientWellness } from "../../App";

const CategoriesForm = ({
  setupdateData,
  updateData,
  formTrigger,
  title,
  setFormTrigger,
}) => {
  const rDescription = useRef();

  const [addSurveyCategory, { loading: loadingSurvey }] =
    useMutation(SAVE_SURVEY_CATEGORY);

  const [createTheme, { loading: loadingTheme }] = useMutation(CREATE_THEME, {
    client: clientWellness,
  });

  const [addQuestionCategory, { loading: loadingQuestion }] = useMutation(
    SAVE_QUESTION_CATEGORY
  );
  const [updateQuestionCategory, { loading: loadingQuestionUpdate }] =
    useMutation(UPDATE_CATEGORY_QUESTION);

  const [updateCategorySurvey, { loading: loadingSurveyUpdate }] = useMutation(
    UPDATE_CATEGORY_SURVEY
  );

  const [updateTheme, { loading: loadingThemeUpdate }] = useMutation(
    UPDATE_THEME,
    {
      client: clientWellness,
    }
  );

  const handleSend = () => {
    let description = rDescription.current.value;
    if (description) {
      switch (formTrigger) {
        case "survey":
          if (updateData.idCategorySurvey) {
            updateCategorySurvey({
              variables: {
                idCategorySurvey: updateData.idCategorySurvey,
                categoryDescription: rDescription.current.value,
                lastUpdateUser: getStateLogin(),
              },
            })
              .then((response) => {
                if (response.data.updateCategorySurvey.withError) {
                  NotificationManager.warning(
                    response.data.updateCategorySurvey.message,
                    "",
                    5000
                  );
                } else {
                  NotificationManager.success(
                    "The category was successfully updated",
                    "",
                    5000
                  );
                  setFormTrigger("");
                  setupdateData({});
                }
              })
              .catch((error) => {
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          } else {
            addSurveyCategory({
              variables: {
                categorySurvey: description,
                userCreateCategorySurvey: getStateLogin(),
              },
            })
              .then((response) => {
                if (response.data.createCategorySurvey.withError) {
                  NotificationManager.warning(
                    response.data.createCategorySurvey.message,
                    "",
                    5000
                  );
                } else {
                  NotificationManager.success(
                    "The survey category was successfully added",
                    "",
                    5000
                  );
                  setFormTrigger("");
                }
              })
              .catch((error) => {
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          }
          break;
        case "question":
          if (updateData.idCategoryQuestion) {
            updateQuestionCategory({
              variables: {
                idCategoryQuestion: updateData.idCategoryQuestion,
                description: rDescription.current.value,
                lastUpdateUser: getStateLogin(),
              },
            })
              .then((response) => {
                if (response.data.updateCategoryQuestion.withError) {
                  NotificationManager.warning(
                    response.data.updateCategoryQuestion.message,
                    "",
                    5000
                  );
                } else {
                  NotificationManager.success(
                    "The question category was successfully updated",
                    "",
                    5000
                  );
                  setFormTrigger("");
                  setupdateData({});
                }
              })
              .catch((error) => {
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          } else {
            addQuestionCategory({
              variables: {
                categoryQuestion: description,
                userCreateCategory: getStateLogin(),
              },
            })
              .then((response) => {
                if (response.data.createCategoryQuestion.withError) {
                  NotificationManager.warning(
                    response.data.createCategoryQuestion.message,
                    "",
                    5000
                  );
                } else {
                  NotificationManager.success(
                    "The question category was successfully added",
                    "",
                    5000
                  );
                  setFormTrigger("");
                }
              })
              .catch((error) => {
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          }
          break;
        case "theme":
          if (updateData?.idCounsellingTheme) {
            updateTheme({
              variables: {
                counsellingThemeId: updateData.idCounsellingTheme,
                themeName: rDescription.current.value,
              },
            })
              .then((response) => {
                if (response.data.updateCounsellingTheme.idCounsellingTheme) {
                  NotificationManager.success(
                    "The category was successfully updated",
                    "",
                    5000
                  );
                  setFormTrigger("");
                  setupdateData({});
                } else {
                  NotificationManager.warning(
                    response.data.updateCategorySurvey.message,
                    "",
                    5000
                  );
                }
              })
              .catch((error) => {
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          } else {
            createTheme({
              variables: {
                themeName: description,
              },
            })
              .then((response) => {
                if (response.data.createCounsellingTheme.idCounsellingTheme) {
                  NotificationManager.success(
                    "The theme category was successfully added",
                    "",
                    5000
                  );
                  setFormTrigger("");
                } else {
                  NotificationManager.warning(
                    response.data.createCategorySurvey.message,
                    "",
                    5000
                  );
                }
              })
              .catch((error) => {
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          }
          break;

        default:
          break;
      }
    }
  };

  useEffect(() => {
    if (
      updateData.description ||
      updateData.categoryDescription ||
      updateData.themeName
    )
      rDescription.current.value =
        updateData.description ||
        updateData.categoryDescription ||
        updateData.themeName;
  }, [updateData]);

  return (
    <GeneralStyle>
      {loadingSurvey ||
      loadingQuestion ||
      loadingQuestionUpdate ||
      loadingTheme ||
      loadingThemeUpdate ||
      loadingSurveyUpdate ? (
        <h2>
          {" "}
          {updateData?.idCategoryQuestion ||
          updateData?.idCategorySurvey ||
          updateData?.idCounsellingTheme
            ? "Updating..."
            : "Saving..."}
        </h2>
      ) : (
        <FormCard>
          <SectionWrapper>
            <h1>{title}</h1>
            <CloseIcon
              onClick={() => {
                setFormTrigger("");
                setupdateData({});
              }}
            />
            <hr />
          </SectionWrapper>
          <SectionWrapper>
            <label>Description</label>
            <textarea maxLength="100" ref={rDescription}></textarea>
          </SectionWrapper>
          <button type="submit" onClick={() => handleSend()}>
            {updateData?.idCategoryQuestion ||
            updateData?.idCategorySurvey ||
            updateData?.idCounsellingTheme
              ? "Update Category"
              : "Create Category"}
          </button>
        </FormCard>
      )}
    </GeneralStyle>
  );
};

CategoriesForm.propTypes = {
  setFormTrigger: func.isRequired,
  title: string.isRequired,
  formTrigger: string.isRequired,
};

export default CategoriesForm;
